import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";

const initialState: any = {
    id: null,
    open: false,
    headerTitle: "Cambium Networks",
    enableHeaderCloseBtn: true,
    content: "",
    cancelBtn: true,
    submitBtn: true,
    submitBtnDisabled: null,
    closeBtnTitle: 'Close',
    submitBtnTitle: 'Submit',
    closeBtnAction: null,
    submitBtnAction: null,
    submitBtnLoading: null,
    keyboard: false,
    backdrop: 'static',
    alertDialog: false
}

export const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        updateModal: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).forEach((id: string) => {
                state[id] = action.payload[id]
            })
        },
        resetModal: () => initialState
    }
})

export const { updateModal, resetModal } = modalSlice.actions;
export const selectModalState = (state: RootState) => state.modal;

export default modalSlice.reducer;
